import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../Layout';
import Category from '../../presentational/Category';

const crumbs = [
  { content: 'Ana Sayfa', url: '/' },
  { content: 'Başarılı Proje Adımları'},
];

const count = 5;

const author = 'Hasan Murat Özen';

const avatars = [
  'https://via.placeholder.com/250x250',
  'https://via.placeholder.com/250x250',
];

const title = 'Başarılı Proje Adımları';
const subtitle = '....................';

const documents = [
  { title: 'Sınırlı Kaynakları Yönetebilmek için', content: '......', url: '/Methodology/15', avatarUrl: 'https://via.placeholder.com/250x250', author: 'Hasan Murat Özen', timeStamp: 'Ekim 2019' },
  { title: 'Kar edebilmek için', content: '......', url: '/Methodology/15', avatarUrl: 'https://via.placeholder.com/250x250', author: 'Azerhan Özen', timeStamp: 'Eylül 2019' },
  { title: 'Mutlu olmak için', content: '......', url: '/Methodology/15', avatarUrl: 'https://via.placeholder.com/250x250', author: 'Hasan Murat Özen', timeStamp: 'Eylül 2019' },
];

export default class Contact extends Component {
  render() {
    return(
      <Layout>
        <Category
          title={title}
          subtitle={subtitle}
          crumbs={crumbs}
          count={count}
          author={author}
          avatars={avatars}
          documents={documents}
        />
      </Layout>
    );
  }
};
